module.exports = __webpack_public_path__ + "static/media/MZW_01.d40bd7ca.jpg";